import {
  QueryCache,
  MutationCache,
  QueryClient,
} from '@tanstack/react-query';

const queryCache = new QueryCache({
  onError: (error, query) => {
    console.error('Query error', { error, queryKey: query.queryKey });
  },
});

const mutationCache = new MutationCache({
  onError: (error, _variables, _context, mutation) => {
    console.error('Mutation error', {
      error,
      mutationKey: mutation.options.mutationKey,
    });
  },
});

const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
